import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '../../assets/images/activity/recruit_header.png'
import _imports_1 from '../../assets/images/activity/recruit_container.png'
import _imports_2 from '../../assets/images/activity/recruit_btn.png'
import _imports_3 from '../../assets/images/activity/recruit_logo.png'
import _imports_4 from '../../assets/images/loading.png'


const _hoisted_1 = { class: "recruit-con" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "recruit-header"
}, null, -1)
const _hoisted_3 = { class: "recruit-main" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("img", { src: _imports_1 }, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_3,
  class: "recruit-logo"
}, null, -1)
const _hoisted_6 = {
  key: 0,
  class: "my-loading"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("img", { src: _imports_4 }, null, -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("p", null, "内容加载中…", -1)
const _hoisted_9 = [
  _hoisted_7,
  _hoisted_8
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _createElementVNode("img", {
        src: _imports_2,
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.joinPublicity && _ctx.joinPublicity(...args))),
        class: "recruit-btn"
      })
    ]),
    _hoisted_5,
    (_ctx.isJoin)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, _hoisted_9))
      : _createCommentVNode("", true)
  ]))
}